import { Button } from "@components/button/button-untitledui";
import { CheckCircle, XClose } from "@untitledui/icons";

type InfractionConnectSuccessViewProps = {
	onAccessModule: () => void;
	onClose: () => void;
};

export function InfractionConnectSuccessView({
	onAccessModule,
	onClose,
}: InfractionConnectSuccessViewProps) {
	return (
		<div
			className="relative flex w-full flex-col p-6"
			data-slot="infraction-connect-success-view"
		>
			<button
				aria-label="Fechar"
				className="absolute top-4 right-4 rounded-lg p-2 text-quaternary hover:bg-secondary_subtle"
				onClick={onClose}
				tabIndex={0}
				type="button"
			>
				<XClose className="size-5" />
			</button>
			<div className="mb-4 flex size-12 items-center justify-center rounded-full bg-success-50">
				<CheckCircle aria-hidden className="size-6 text-success-primary" />
			</div>
			<h2 className="pr-8 font-semibold text-lg text-primary">
				Sua empresa foi conectada com sucesso!
			</h2>
			<p className="mt-2 text-secondary text-sm">
				Clique no botão abaixo para ser direcionado para a tela principal do
				Módulo de Gestão de Infrações
			</p>
			<div className="mt-8 flex justify-end">
				<Button
					aria-label="Acessar módulo"
					color="primary"
					onClick={onAccessModule}
					size="md"
					tabIndex={0}
				>
					Acessar Módulo
				</Button>
			</div>
		</div>
	);
}
